import type { MessageDescriptor } from 'react-intl';

import { BillingPlanIds, isStarterPlan, isStandardPlan } from '../../../../../../enums/billing-plan-ids';

import { messages } from './messages';

type DowngradeConfirmationContent = {
  bannerMessage?: MessageDescriptor;
  primaryMessage: MessageDescriptor;
  featureMessages: ReadonlyArray<MessageDescriptor>;
};

const FREE_CONTENT: DowngradeConfirmationContent = {
  bannerMessage: messages.userRoleWarning,
  primaryMessage: messages.freeDowngradePrimaryText,
  featureMessages: [],
};

const getStarterContent = (isShipstationReturnsEnabled: boolean): DowngradeConfirmationContent => ({
  bannerMessage: messages.userRoleWarning,
  primaryMessage: messages.downgradePrimaryText,
  featureMessages: [
    messages.userSeats,
    messages.bringYourOwnCarrier,
    messages.combineSplitShipments,
    messages.unlimitedAutomationRules,
    messages.customRateShopper,
    messages.brandedTracker,
    ...(isShipstationReturnsEnabled ? [messages.returnsPortal] : [messages.legacyReturnsPortal]),
    messages.inventoryWarehouseManagement,
    messages.advancedAnalytics,
    messages.dataExport,
    messages.customStore,
    messages.shippingApi,
    messages.phoneSupport,
  ],
});

const STANDARD_CONTENT: DowngradeConfirmationContent = {
  primaryMessage: messages.downgradePrimaryText,
  featureMessages: [
    messages.dedicatedAccountManager,
    messages.userSeats,
    messages.advancedInventory,
    messages.warehouse,
    messages.customReports,
    messages.cubiscanIntegration,
    messages.odbcIntegration,
  ],
};

export const getDowngradeConfirmationContent = (
  billingPlanId: string | number | null | undefined,
  isShipstationReturnsEnabled: boolean,
): DowngradeConfirmationContent | undefined => {
  if (billingPlanId == null) return undefined;

  const parsed = typeof billingPlanId === 'number' ? billingPlanId : parseInt(String(billingPlanId), 10);

  if (parsed === BillingPlanIds.Free2025Q2) return FREE_CONTENT;
  if (isStarterPlan(billingPlanId)) return getStarterContent(isShipstationReturnsEnabled);
  if (isStandardPlan(billingPlanId)) return STANDARD_CONTENT;

  return undefined;
};
